import React from 'react';
import { VodapayLogoV2 } from 'src/assets/images';
import { cn } from 'src/utils/cn';

type VodaPayLogoV2Props = {
  className?: string;
};

export const VodaPayLogoV2 = ({ className }: VodaPayLogoV2Props) => {
  return <img className={cn('absolute left-10 top-8', className)} src={VodapayLogoV2} />;
};
